var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall192SvgrepoCom1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_207_1325)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5685 20.7938C22.8277 23.045 19.9253 24.1677 17.8517 23.9805C15.0197 23.7245 11.9381 22.2224 9.59888 20.568C6.16048 18.136 2.93967 14.3741 1.06287 10.3821C-0.263527 7.56128 -0.561124 4.09312 1.41168 1.52192C2.14128 0.571519 2.93007 0.0639317 4.11567 0.00473173C5.76047 -0.0752683 5.99088 0.865694 6.55568 2.33129C6.97648 3.42729 7.53807 4.54529 7.85167 5.68129C8.43887 7.80129 6.38607 7.8899 6.12687 9.6227C5.96527 10.7155 7.29008 12.181 7.88848 12.9602C9.06128 14.4866 10.4709 15.8031 12.0613 16.8047C12.9717 17.3791 14.4421 18.4142 15.4853 17.843C17.0917 16.963 16.9397 14.2543 19.1861 15.1711C20.3493 15.6447 21.4757 16.3282 22.5861 16.9266C24.3029 17.8498 24.2229 18.8066 23.5685 20.7938C24.0581 19.309 23.0789 22.2786 23.5685 20.7938Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_207_1325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall192SvgrepoCom1);
export default __webpack_public_path__ + "static/media/call-192-svgrepo-com 1.761c72843694f3df19001f57c58139bb.svg";
export { ForwardRef as ReactComponent };